/** Web company management is the session role, not a separate admin flag. */
export function canManageCompany(role: string | undefined): role is 'owner' | 'admin' {
  return role === 'owner' || role === 'admin';
}
